// API Base Url
export const API_DOMAIN = 'https://dokan.ajaira.website';
export const API_DOMAIN_LOCAL = 'http://localhost:8888/dokan';

// API VERSION
export const API_ENDPOINT_BASE_DOKAN = '/wp-json/dokan/v1';
export const API_ENDPOINT_BASE_WC = '/wp-json/wc/v3';
